'use strict';

angular.module('bmmLibApp', []);
